<template>
  <div class="flag-icon" :style="style">
    <div
      v-if="isoCode"
      :class="`fi fib fi-${(isoCode || '').toLowerCase()}`"
      :style="style"
      :title="isoCode"
    />
    <div
      v-else
      class="flag-placeholder flag-placeholder--empty"
      :style="style"
      aria-hidden="true"
    >
      <span class="flag-placeholder-text">?</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  isoCode?: string
  width?: number
  borderRadius?: number
}>(), {
  width: 32,
  borderRadius: 2,
})

const style = computed(() => ({
  width: `${props.width}px`,
  height: `${Math.round(props.width / (4 / 3))}px`,
  borderRadius: `${props.borderRadius}px`,
}))
</script>

<style scoped>
.flag-icon {
  display: inline-block;
  overflow: hidden;
}

.flag-icon :deep(.fi) {
  position: relative;
  flex-shrink: 0;
  background-size: contain;
  background-position: 50%;
  background-repeat: no-repeat;
}

.flag-icon :deep(.fi::before) {
  content: " ";
  position: absolute;
}

.flag-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  /* background: var(--color-grey-light, #E5E7EB); */
  border: 1px solid var(--color-grey, #868D98);
  flex-shrink: 0;
}

.flag-placeholder--empty {
  /* background: var(--color-grey-light, #E5E7EB); */
  border: 1px dashed var(--color-grey, #868D98);
}

.flag-placeholder-text {
  font-family: var(--font-inter);
  font-size: 1em;
  font-weight: 200;
  color: var(--color-grey, #868D98);
  line-height: 1;
  user-select: none;
}
</style>
